import { Button } from '@sparemin/blockhead';
import IconModal from 'components/IconModal';
import { useNotification } from 'components/Notification';
import { HEADLINER_EMAIL_SETTINGS_URL } from 'config';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useConnectedModal, useModalControls } from 'state/modals';
import {
  useIsEmailVerified,
  useProfileInfo,
  userProfileQueries,
  useVerifyEmail,
} from 'state/user';
import * as S from './styles';

type VerifyEmailModalProps = {};

export const MODAL_NAME = 'VerifyEmail';

const VerifyEmailModal: React.FC<VerifyEmailModalProps> = () => {
  const { mutate: verify } = useVerifyEmail();
  const { data: userInfo } = useProfileInfo();
  const { refetch } = useIsEmailVerified();
  const { email, userId } = userInfo ?? {};
  const { showError } = useNotification();
  const { close } = useModalControls();
  const { params } = useConnectedModal({ name: 'VerifyEmail' });
  const { onVerify } = params ?? {};
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    if (userId) {
      queryClient.invalidateQueries(userProfileQueries.user(userId));
      refetch().then(
        (res) => {
          if (res.data === true) {
            close();
            onVerify?.();
          }
          if (!res.data) {
            showError(
              "Account is not verified. If you can't find your verification email, try resending it.",
            );
          }
        },
        () => {
          showError('Error checking validation. Try again.');
        },
      );
    }
  };

  return (
    <IconModal
      modalName={MODAL_NAME}
      title="Please verify your email first"
      subtitle={`We sent a verification to ${email}. If you can’t find it, please check your spam or choose an option below.`}
    >
      <Button onPress={() => verify()} fluid>
        resend verification
      </Button>
      <S.Spacer>
        <Button onPress={handleRefresh} fluid variant="ghost">
          Check again
        </Button>
        <Button
          as="a"
          variant="ghost"
          fluid
          href={HEADLINER_EMAIL_SETTINGS_URL}
          rel="noreferrer"
          target="_blank"
        >
          change email
        </Button>
      </S.Spacer>
    </IconModal>
  );
};

export default VerifyEmailModal;
